module.exports = __webpack_public_path__ + "static/media/apartment-large.281bf4a2.png";